import { Nutrient } from "@/types";

// TODO: Is there a library that can provide this data instead of hardcoding?
export const countries = [
  { label: "Afghanistan", value: "AF" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Brazil", value: "BR" },
  { label: "Brunei", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cabo Verde", value: "CV" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo, Democratic Republic of the", value: "CD" },
  { label: "Congo, Republic of the", value: "CG" },
  { label: "Costa Rica", value: "CR" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Eswatini", value: "SZ" },
  { label: "Ethiopia", value: "ET" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Greece", value: "GR" },
  { label: "Grenada", value: "GD" },
  { label: "Guatemala", value: "GT" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Honduras", value: "HN" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, North", value: "KP" },
  { label: "Korea, South", value: "KR" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Laos", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia", value: "FM" },
  { label: "Moldova", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "North Macedonia", value: "MK" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestine", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Qatar", value: "QA" },
  { label: "Romania", value: "RO" },
  { label: "Russia", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Sudan", value: "SS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syria", value: "SY" },
  { label: "Taiwan", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Vatican City", value: "VA" },
  { label: "Venezuela", value: "VE" },
  { label: "Vietnam", value: "VN" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

// TODO: Is there a library that can provide this data instead of hardcoding?
export const currencies = {
  EUR: { symbol: "€", label: "Euro" },
  USD: { symbol: "$", label: "US Dollar" },
  GBP: { symbol: "£", label: "British Pound" },
  CAD: { symbol: "CA$", label: "Canadian Dollar" },
  AUD: { symbol: "A$", label: "Australian Dollar" },
  JPY: { symbol: "¥", label: "Japanese Yen" },
  CNY: { symbol: "¥", label: "Chinese Yuan" },
  INR: { symbol: "₹", label: "Indian Rupee" },
  RUB: { symbol: "₽", label: "Russian Ruble" },
  BRL: { symbol: "R$", label: "Brazilian Real" },
};

export type CurrencyCode = keyof typeof currencies;

export const measurementSystems = ["metric", "imperial"] as const;

/**
 * EU recognized allergens.
 *
 * Source: https://www.fsai.ie/business-advice/labelling/labelling-allergens
 *
 * TODO: Eventually labels should be localized.
 */
export const allergens = [
  { value: 0, label: "Wheat", abbreviation: "WG" },
  { value: 1, label: "Rye", abbreviation: "RG" },
  { value: 2, label: "Barley", abbreviation: "BG" },
  { value: 3, label: "Oat", abbreviation: "OG" },
  { value: 4, label: "Crustaceans", abbreviation: "C" },
  { value: 5, label: "Eggs", abbreviation: "E" },
  { value: 6, label: "Fish", abbreviation: "F" },
  { value: 7, label: "Peanuts", abbreviation: "PN" },
  { value: 8, label: "Soybeans", abbreviation: "S" },
  { value: 9, label: "Milk", abbreviation: "MK" },
  { value: 10, label: "Almonds", abbreviation: "AN" },
  { value: 11, label: "Hazelnuts", abbreviation: "HN" },
  { value: 12, label: "Walnuts", abbreviation: "WN" },
  { value: 13, label: "Cashews", abbreviation: "CN" },
  { value: 14, label: "Pecan nuts", abbreviation: "PNN" },
  { value: 15, label: "Brazil nuts", abbreviation: "BN" },
  { value: 16, label: "Pistachio nuts", abbreviation: "PON" },
  { value: 17, label: "Macadamia nuts", abbreviation: "MN" },
  { value: 18, label: "Celery", abbreviation: "CY" },
  { value: 19, label: "Mustard", abbreviation: "MD" },
  { value: 20, label: "Sesame seeds", abbreviation: "SS" },
  { value: 21, label: "Sulphur dioxide and sulphites", abbreviation: "SP" },
  { value: 22, label: "Lupin", abbreviation: "L" },
  { value: 23, label: "Molluscs", abbreviation: "M" },
];

// Define nutrition fields configuration - SINGLE SOURCE OF TRUTH
// Info from: https://www.fsai.ie/getmedia/d7e3c1bd-546c-4532-afec-ededab679c0f/10163_fsai_food_health_claims_agr_accessible_1.pdf?ext=.pdf
interface NutritionField {
  key: Nutrient;
  label: string;
  unit: string;
  description?: string;
  isSubField?: boolean; // For "of which" fields
  parent?: Nutrient; // Parent field for sub-fields
}

/**
 * EU allowed and mandatory nutrition fields.
 */
export const nutrients: NutritionField[] = [
  { key: "fat", label: "Fat", unit: "g" },
  {
    key: "fat_saturated",
    label: "of which saturates",
    unit: "g",
    isSubField: true,
    parent: "fat",
  },
  {
    key: "fat_monounsaturates",
    label: "of which monounsaturates",
    unit: "g",
    isSubField: true,
    parent: "fat",
  },
  {
    key: "fat_polyunsaturates",
    label: "of which polyunsaturates",
    unit: "g",
    isSubField: true,
    parent: "fat",
  },
  { key: "carbohydrate", label: "Carbohydrate", unit: "g" },
  {
    key: "carbohydrate_sugars",
    label: "of which sugars",
    unit: "g",
    isSubField: true,
    parent: "carbohydrate",
  },
  {
    key: "carbohydrate_polyols",
    label: "of which polyols",
    unit: "g",
    isSubField: true,
    parent: "carbohydrate",
  },
  {
    key: "carbohydrate_starch",
    label: "of which starch",
    unit: "g",
    isSubField: true,
    parent: "carbohydrate",
  },
  { key: "fibre", label: "Fibre", unit: "g" },
  { key: "protein", label: "Protein", unit: "g" },
  { key: "salt", label: "Salt", unit: "g" },
];
